import { createContext } from 'react';

export const DefinitionsContext = createContext(null);